import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "../../api/client";

export const fetchPlans = createAsyncThunk(
  "plans/fetchPlans",
  async (arg, thunkApi) => {
    const res = await apiRequest("api/plans", { method: "GET" });

    if (!res.ok) {
      const errors = Array.isArray(res.data?.errors) ? res.data.errors : null;
      return thunkApi.rejectWithValue(
        errors?.join("\n") ||
          res.data?.message ||
          "Failed to fetch subscription plans."
      );
    }

    // API returns an array of plans (or a message object when none exist).
    return Array.isArray(res.data) ? res.data : [];
  },
  {
    // Avoid duplicate calls (e.g. React StrictMode).
    condition: (arg, { getState }) => {
      if (arg?.force) return true;
      const state = getState();
      const plansState = state?.plans;
      if (!plansState) return true;
      return plansState.status === "idle" || plansState.status === "failed";
    },
  }
);

export const createCheckoutSession = createAsyncThunk(
  "plans/createCheckoutSession",
  async (planId, thunkApi) => {
    const res = await apiRequest("api/billing/checkout_session", {
      method: "POST",
      body: { plan_id: planId },
    });

    if (!res.ok) {
      const errors = Array.isArray(res.data?.errors) ? res.data.errors : null;
      return thunkApi.rejectWithValue(
        errors?.join("\n") ||
          res.data?.message ||
          "Failed to create checkout session."
      );
    }

    return res.data || { id: null, url: null };
  }
);

const plansSlice = createSlice({
  name: "plans",
  initialState: {
    status: "idle", // idle | loading | succeeded | failed
    error: "",
    items: [],
    checkoutStatus: "idle", // idle | loading | succeeded | failed
    checkoutError: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlans.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(fetchPlans.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = "";
        state.items = action.payload || [];
      })
      .addCase(fetchPlans.rejected, (state, action) => {
        state.status = "failed";
        state.error =
          typeof action.payload === "string"
            ? action.payload
            : "Failed to fetch subscription plans.";
        state.items = [];
      })
      .addCase(createCheckoutSession.pending, (state) => {
        state.checkoutStatus = "loading";
        state.checkoutError = "";
      })
      .addCase(createCheckoutSession.fulfilled, (state) => {
        state.checkoutStatus = "succeeded";
      })
      .addCase(createCheckoutSession.rejected, (state, action) => {
        state.checkoutStatus = "failed";
        state.checkoutError =
          typeof action.payload === "string"
            ? action.payload
            : "Failed to create checkout session.";
      });
  },
});

export default plansSlice.reducer;

